import crownIcon from "../components/icons/Bold/Essentional, UI/Crown.png";
import giftIcon from "../components/icons/Bold/Essentional, UI/Gift.png";
import ticketIcon from "../components/icons/Bold/Money/Ticket Sale.png";

const gamificationCards = [
  {
    title: "Reward Your Ambassadors",
    description: "Boost campaign performance by setting up rewards for ambassadors",
    icon: giftIcon,
  },
  {
    title: "Set Milestones",
    description: "Set up custom goals for sales, posts, or time-based achievements",
    icon: crownIcon,
  },
  {
    title: "Customise Incentives",
    description: "Create custom incentives like flat fees, free products, or special commissions.",
    icon: ticketIcon,
  },
];

export default gamificationCards;
